<template>
  <div class="result-modal" v-if="visible">
    <div class="modal-bg" :style="{ backgroundImage: `url(${modalImage})` }">
      <!-- 🏆 Title -->
      <div class="title">
        <template v-if="profit >= 0">
          {{ $t('gameResult.congratulations') }}
        </template>
        <template v-else>
          {{ $t('gameResult.youLost') }} <span class="emoji">😭</span>
        </template>
      </div>

      <!-- 🎯 Result -->
      <div class="lottery-result">
        <img :src="colorImage" alt="color" class="result-img" />
        <img :src="numberImage" alt="number" class="result-img" />
      </div>

      <!-- 🧾 No bet -->
      <div v-if="!userBet" class="info">
        {{ $t('gameResult.noBetsPlaced') }}
      </div>

      <!-- 💰 Bet Info -->
      <div v-else class="info">
        <!-- TOP LINE: Total Bet & Win -->
        <div class="top-line">
          <span class="label">{{ $t('gameResult.totalBet') }}:</span>
          <span>{{ totalBet }} {{ getCurrencySymbol(currency) }}</span>

          <span class="label">| {{ $t('gameResult.totalWin') }}:</span>
          <span>{{ totalWin }} {{ getCurrencySymbol(currency) }}</span>
        </div>

        <!-- BOTTOM LINE: Total Profit -->
        <div class="profit-line" :class="profit >= 0 ? 'profit' : 'loss'">
          {{ $t('gameResult.totalProfit') }}:
          {{ profit >= 0 ? '+' : '-' }}{{ Math.abs(profit) }} {{ getCurrencySymbol(currency) }}
        </div>
      </div>

      <!-- 🆔 Round ID -->
      <div class="round-id">{{ $t('gameResult.roundId') }}: {{ roundId }}</div>

      <!-- ❌ Close -->
      <button class="close-btn" @click="close">{{ $t('gameResult.close') }}</button>
    </div>
  </div>
</template>

<script setup>
import { computed, watch, ref } from 'vue'
import { wingoImages } from '@/assets/wingoAssets'
import winSoundFile from '@/assets/sounds/win.mp3'
import loseSoundFile from '@/assets/sounds/lose.mp3'

const props = defineProps({
  visible: Boolean,
  result: Object
})

const emit = defineEmits(['close'])

const totalBet = computed(() => props.result?.totalBet || 0)
const totalWin = computed(() => props.result?.totalWin || 0)
const profit = computed(() => props.result?.profit || 0)
const currency = computed(() => props.result?.currency || '')
const roundId = computed(() => props.result?.roundId || '')
const userBet = computed(() => props.result?.userBet || false)
const colorImage = computed(() => wingoImages[props.result?.color] || '')
const numberImage = computed(() => wingoImages[props.result?.number] || '')

const modalWinImage = new URL('@/assets/img/modalbg.png', import.meta.url).href
const modalLoseImage = new URL('@/assets/img/modallosebg.png', import.meta.url).href
const modalImage = computed(() => profit.value < 0 ? modalLoseImage : modalWinImage)

const getCurrencySymbol = (code) => {
  const map = {
    TRY: '₺', USD: '$', EUR: '€', IDR: 'Rp', INR: '₹', CNY: '¥', BRL: 'R$'
  }
  return map[code] || code
}

// 🔒 En son ses çalınan round id
const lastPlayed = ref(null)

// ✅ Sadece görünür OLDUĞUNDA ve roundId DEĞİŞTİĞİNDE ses çalsın
watch(
  () => props.visible,
  (visible) => {
    const round = props.result?.roundId
    if (visible && round && round !== lastPlayed.value) {
      lastPlayed.value = round

      const sound = new Audio(profit.value >= 0 ? winSoundFile : loseSoundFile)
      sound.play().catch(e => console.warn('Ses hatası:', e))

      setTimeout(() => {
        emit('close')
        lastPlayed.value = null // round bittiğinde tekrar izin ver
      }, 3000)
    }
  }
)
</script>













<style scoped>
.result-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-bg {
  width: 300px;
  height: 460px;
  background-size: cover;
  background-position: center;
  position: relative;
  padding: 30px 20px;
  text-align: center;
  color: #000;
  font-weight: bold;
  font-family: 'Poppins', sans-serif;
}

.amount-line {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
  font-weight: bold;
  font-size: 10px;
}

.amount-line .label {
  opacity: 0.7;
}
.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 12px;
      margin-top: 100px;
}

.lottery-result {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 16px;
  margin-top: 40px;
}

.result-img {
  width: 42px;
  height: auto;
}

.info {
  font-size: 16px;
  margin-bottom: 10px;
  margin-top: 50px;
}

.amount-line {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.coin-icon {
  width: 20px;
  height: 20px;
}

.profit {
  color: #00ff94;
  font-weight: bold;
}

.loss {
  color: #ff5555;
  font-weight: bold;
}

.round-id {
  font-size: 12px;
  margin-top: 32px;
  color: #000;
}

.close-btn {
  margin-top: 12px;
  padding: 6px 12px;
  background: var(--button1);
  color: #000;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;
      margin-top: 70px;
}

.top-line {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 12px;
  margin-bottom: 8px;
}

.profit-line {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-top: 15px;
}

.emoji {
  font-size: 28px;
  margin-left: 6px;
  display: inline-block;
  transform: translateY(3px); /* biraz aşağı hizalama */
}
</style>
